/**
 * AgentTriggerButton
 *
 * Botón del robot ("Tu agente") de la barra superior. Lleva a /agente
 * (conectarse por Kane OneDeck o ChatGPT y ver el handbook). Lo comparten
 * el portal principal (PrivateLayout) y el del técnico (TechnicianHeader)
 * para que ícono, nombre accesible y destino no diverjan.
 *
 * aria-label lo nombra de verdad (los `title` no se muestran en touch ni los
 * lectores de pantalla los tratan como nombre); el title queda de tooltip.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import './PrivateLayout.css';

const AgentTriggerButton = ({ className = 'navbar-icon-btn me-1' }) => {
  const navigate = useNavigate();
  return (
    <Button
      variant="link"
      className={className}
      onClick={() => navigate('/agente')}
      aria-label="Tu agente: conectarte y ver qué sabe hacer"
      title="Tu agente"
      data-testid="kane-assistant-trigger"
    >
      <i className="bi bi-robot" aria-hidden="true"></i>
    </Button>
  );
};

export default AgentTriggerButton;
